import React from "react";
import { AppBar, Toolbar, Typography, Button } from "@mui/material";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
}));

const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
});

const StyledButton = styled(Button)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  "&:hover": {
    backgroundColor: theme.palette.secondary.light,
  },
}));

const StyledTypography = styled(Typography)({
  textDecoration: "none",
  color: "inherit",
});

const Header = () => {
  return (
    <StyledAppBar position="static">
      <StyledToolbar>
        <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <StyledTypography variant="h6">Google Cloud Architect Guide</StyledTypography>
        </Link>
        <div>
          <StyledButton color="inherit" component={Link} to="/">
            Home
          </StyledButton>
          <StyledButton color="inherit" component={Link} to="/opinion">
            Opinion
          </StyledButton>
          <StyledButton color="inherit" component={Link} to="/about">
            About
          </StyledButton>
          <StyledButton color="inherit" component={Link} to="/chat">
            Chat
          </StyledButton>
        </div>
      </StyledToolbar>
    </StyledAppBar>
  );
};

export default Header;
